<template>
    <order-offer-map/>
</template>

<script>
import OrderOfferMap from './Comps/OrderOfferMap'
export default {
    components: {OrderOfferMap},
}
</script>

<style>

</style>